// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QV8r","type":"styles_type__1ZaWl","choices":"styles_choices__1ElEc"};